import DrawerGlow1 from './drawer-icon/1.svg';
import DrawerGlow2 from './drawer-icon/2.svg';
import DrawerGlow3 from './drawer-icon/3.svg';
import DrawerGlow4 from './drawer-icon/4.svg';
import DrawerGlow5 from './drawer-icon/5.svg';
import DrawerGlow6 from './drawer-icon/6.svg';
import DrawerGlow7 from './drawer-icon/7.svg';
import DrawerGlow8 from './drawer-icon/8.svg';
import DrawerGlow9 from './drawer-icon/9.svg';
import DrawerEMPTY from './drawer-icon/empty.svg';

import { EMPTY_EFFECT } from '../../preset-util/base-preset-util';
import NoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/no_effect_fill_44.svg';
import ShapeNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/shape_noeffect_44.svg';
import TextNoEffectFill from '@tencent/docs-design-resources/icon/desktop/svg/text_noeffect_44.svg';


export {
    DrawerGlow1,
    DrawerGlow2,
    DrawerGlow3,
    DrawerGlow4,
    DrawerGlow5,
    DrawerGlow6,
    DrawerGlow7,
    DrawerGlow8,
    DrawerGlow9,
    DrawerEMPTY,
};

export const IMAGE_PRESET_ICONS = {
    [EMPTY_EFFECT]: NoEffectFill,
};

export const SHAPE_PRESET_ICONS = {
    [EMPTY_EFFECT]: ShapeNoEffectFill,
};

export const TEXT_PRESET_ICONS = {
    [EMPTY_EFFECT]: TextNoEffectFill,
};

